export default "/images/vendor/flag-icon-css/flags/4x3/dg.svg?b23bebbbe36225a7fea28a0bd5622496";